<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'reservations' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="btn-group">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#coll1"
            aria-expanded="true"
            aria-controls="coll1"
            class="btn btn-default btn-sm"
          >
            <i class="fa fa-sort mr-5"></i>{{'show_hide_filters' | translate}}
          </button>
        </div>
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        <div class="row">
          <div class="col-xs-12">
            <div class="collapse in" id="coll1">
              <div class="pt-10 row">
                <div class="col-md-5 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'company' | translate}}
                    </div>
                    <multiselect
                      v-model="company"
                      :options="companies"
                      :placeholder="'select_one' | translate"
                      label="name"
                      track-by="id"
                      @input="paginate('','')"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-4 col-sm-4">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'status' | translate}}
                    </div>
                    <select class="form-control" v-model="status" @change.prevent="paginate('status')">
                      <option class="normal" value="">Alle</option>
                      <option class="normal" value="1">Der Schuh wurde reserviert</option>
                      <option class="normal" value="2">Die Reservierung wurde vom Händler freigegeben</option>
                      <option class="normal" value="3">Die Reservierung wurde vom Händler storniert</option>
                      <option class="normal" value="4">Die Reservierung wurde von schuhe.de storniert</option>
                      <option class="normal" value="5">Das reservierte Modell (selbe Farbe und Größe) wurde verkauft</option>
                      <option class="normal" value="6">Das reservierte Modell (selbe Farbe => andere Größe) wurde verkauft</option>
                      <option class="normal" value="7">Ein anderes Modell wurde verkauft</option>
                      <option class="normal" value="8">Kunde hat nichts gekauft</option>
                      <option class="normal" value="9">Die Reservierung wurde von schuhe.de storniert -> Kunde hat nicht abgeholt</option>
                      <option class="normal" value="10">Die Reservierung wurde vom Kunden storniert</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'period' | translate}}
                    </div>
                    <date-range-picker
                      :startDate="startRange"
                      :endDate="endRange"
                      id="ordertime"
                      @pepe="onDateRangeChanged"
                    >
                    </date-range-picker>
                  </div>
                </div>
              </div>
              <div class="pt-10 pb-10 row">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="reservationId"
                      class="form-control"
                      :placeholder="'reservation_number' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button
                        type="submit"
                        name="submit"
                        class="btn"
                        >
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="firstName"
                      class="form-control"
                      :placeholder="'first_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button
                        type="submit"
                        name="submit"
                        class="btn"
                      >
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      :disabled="loading"
                      v-model="lastName" class="form-control"
                      :placeholder="'last_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button
                        type="submit"
                        name="submit"
                        class="btn"
                      >
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
          <click-collect-table :orders="pagination.data" @sort="sort($event)"></click-collect-table>
        </template>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
import DateRangePicker from '../tools/DateRangePicker.vue'
export default {
  name: 'OrdersOverview',
  data () {
    return {
      alerts: [],
      loading: false,
      status: '',
      companyId: '',
      firstName: '',
      lastName: '',
      reservationId: '',
	    selectedStart: '',
	    selectedEnd: '',
      dateRange: 'ciao',
      startRange: moment().subtract(1, 'month'),
      endRange: moment(),
      picklist: [],
      products: {},
      channel: 0,
      returns: 0,
      newItems: 0,
      canceled: 0,
      shipped: 0,
      initials: 0,
      open: 0,
      mpCancel: 0,
      customerCancel: 0,
      statuses: [],
      isActive: '',
      sellOnline: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      },
	    companies:[{
		    id: 0,
		    name: 'Alle'
	    }],
	    company: {
		    id: 0,
		    name: 'Alle'
	    },
      backup: [],
      paginate (type, value) {
        this.loading = true
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
        url += `&company_id=${this.company.id}`
        url += `&reservation_id=${this.reservationId}`
        url += `&status=${this.status}`
        url += `&customer_name=${this.lastName}`
        url += `&customer_firstname=${this.firstName}`
        API.get(`/clickAndCollect${url}`)
          .then(response => {
            this.pagination = response.data
            this.pagination.data.forEach(o => {
              o.date_order = o.date_order.split(' ')
              o.date_order[0] = o.date_order[0].split('-').reverse().join('.')
              o.date_order = o.date_order.join(' ')
            })
            window.localStorage.setItem('orderPage', this.pagination.current_page)
            this.filterStatus()
            this.loading = false
          }, error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      }
    }
  },
  components: {
    dateRangePicker: DateRangePicker
  },
  methods: {
    triggerStatus (status) {
      this.selectedStatus = status
      this.paginate('status')
    },
    filterOrders (event) {
      let orders = this.backup
      let status = ''
      this.pagination.data = []
      switch (event) {
        case 1:
          status = 'processing'
          break
        case 2:
          status = 'shipped'
          break
        case 3:
          status = 'returned'
          break
        case 4:
          status = 'canceled'
          break
        default:
          this.pagination.data = this.backup
          break
      }
      for (let x in orders) {
        for (let y in orders[x].status) {
          if (orders[x].status[y].label === status && status !== '') {
            this.pagination.data.push(orders[x])
          }
        }
      }
    },
    onDateRangeChanged (picker) {
      this.dateRange = picker.startDate + ' - ' + picker.endDate
      this.startRange = picker.startDate
      this.endRange = picker.endDate
      this.selectedEnd = this.endRange.format('YYYY-MM-DD')
      this.selectedStart = this.startRange.format('YYYY-MM-DD')
      this.paginate('', '')
    },
    getStatus (label, id) {
      if (id === 1 || id === 2 || id === 5 || id === 6) {
        return {label: label, style: 'label label-success', icon: 'fa fa-check mr-5'}
      } else if (id === 7) {
        return {label: label, style: 'label label-info', icon: 'fa fa-check-circle mr-5'}
      } else {
        return {label: label, style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
    },
    filterStatus () {
      let orders = this.pagination.data
      for (let x in orders) {
        orders[x].status = this.getStatus(orders[x].status, orders[x].status_id)
      }
    },
    sort (value) {
      this.sortType = value
      this.paginate('', '')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loading = true
	    API.get('statistics/companies')
		    .then(res => {
			    res.data.forEach(x => {
			    	this.companies.push(x)
          })
		    })
		    .catch(error => {
			    console.log(error)
		    })
      let url = `?page=${window.localStorage.getItem('orderPage')}`
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get(`/clickAndCollect${url}`)
          .then(response => {
            this.pagination = response.data
            this.backup = response.data.data
            this.pagination.data.forEach(o => {
              o.date_order = o.date_order.split(' ')
              o.date_order[0] = o.date_order[0].split('-').reverse().join('.')
              o.date_order = o.date_order.join(' ')
            })
            this.filterStatus()
            this.loading = false
          })
          .catch(error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal {
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4)
  }
  select option.normal {
    background:#202227
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect::placeholder {
    color: #ffffff !important;
  }
</style>
<style>
  .is-clickable {
    cursor: pointer;
  }
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
</style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
  optgroup.normal {
    background:#202227;
    color:#fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/ClickCollectOverview.vue